module.exports = __webpack_public_path__ + "img/heart.83d4553a.svg";